import { getParent } from 'utils'

import { getTemplateTagOptions } from 'components/Editor/Modals/TemplatePickerModal/hooks'
import { genDataField } from 'components/controls/Field'
import type { TemplateTag } from 'gql/__generated__/graphql'
import { t } from 'services/Translation'

const genField = genDataField<{
  name: string
  templateTagIds: string
  editorTemplateGroupId: string
}>()

export const nameField = genField({
  label: t('input.label.name'),
  name: 'name',
  type: 'text',
  params: { placeholder: t('input.placeholder.name'), autoFocus: true },
  rules: [
    {
      required: true,
      message: t('input.error.required', { field: t('input.label.name') }),
    },
    {
      whitespace: true,
      message: t('input.error.whitespace'),
    },
  ],
})

export const createdForField = (options: { value: string; label: string }[]) =>
  genField({
    label: t('input.label.location'),
    name: 'editorTemplateGroupId',
    type: 'select',
    params: () => ({
      options,
      fluid: true,
      resettable: true,
      isSearch: true,
    }),
    rules: [{ required: true }],
  })

export const templateTagIds = (templateTags: TemplateTag[], disabled: boolean) =>
  genField({
    label: t('input.label.collectionTags'),
    name: 'templateTagIds',
    type: 'select',
    layout: ['vertical', 'free'],
    params: (data, rest) => {
      const isSelectedTemplateGroupId =
        Boolean(
          getParent<{ editorTemplateGroupId: string }>(rest.name, data).parent
            ?.editorTemplateGroupId,
        ) || disabled

      const options = getTemplateTagOptions(templateTags)
      return {
        maxLength: 25,
        max: 25,
        disabled: !isSelectedTemplateGroupId,
        placeholder: t('input.placeholder.collectionTags'),
        fluid: true,
        isMultiple: true,
        resettable: true,
        isSearch: true,
        inputable: true,
        dropdownType: 'dropdown',
        hideEmptyList: true,
        separators: [',', ';'],
        options,
      }
    },
  })

export const InputErrorValues = {
  TEMPLATE_NAME_NOT_UNIQUE: t('input.error.templateNotUnique'),
}
